import React from 'react'

export const BulletIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle opacity="0.8" cx="6" cy="6" r="2.5" fill="#40424A" />
    </svg>
  )
}
